import { Component } from '@angular/core';
import { WorkflowItemKeyDirective } from '@workflow/directives/workflow-item-key/workflow-item-key.directive';

interface ColorWordResults {
	rotgruenblind: boolean,
	zeit1: number,
	zeit2: number,
	zeit3: number,
}

@Component({
	selector: 'workflow-color-word-epilog',
	templateUrl: './color-word-epilog.component.html',
	styleUrls: ['./color-word-epilog.component.scss']
})
export class ColorWordEpilogComponent {
	constructor(public workflowItemKey: WorkflowItemKeyDirective<ColorWordResults>) {}
}
